import React, { useState, useEffect } from 'react'
import Grid from '@material-ui/core/Grid'
import Card from '@material-ui/core/Card'
import CardMedia from '@material-ui/core/CardMedia'
import FavouriteCheckbox from '@/product/components/atoms/FavoriteCheckbox'
import CardContent from '@material-ui/core/CardContent'
import Typography from '@material-ui/core/Typography'
import { NavLink, useHistory, Link } from 'react-router-dom'
import IconButton from '@material-ui/core/IconButton'
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder'
import { handleRedirectInternal, mapData, useCustomMediaQuery } from '@/product/common/components'
const isValidHttpUrl = (string) => {
    let url

    try {
        url = new URL(string)
    } catch (err) {
        return false
    }

    return url.protocol === 'http:' || url.protocol === 'https:'
}
export const OemGrid = (props) => {
    const [product, setProduct] = useState({})
    const history = useHistory()
    useEffect(() => {
        setProduct(props.data)
    }, [props.data])
    let theme = props.theme
    return (
        // <Grid container spacing={3} className="mb-2">
        <>
            <Grid
                item
                // xs={12}
                // sm={6}
                // md={4}
            >
                <Card className="card">
                    <CardMedia
                        onClick={() => handleRedirectInternal(history, `productview/${product.id}`)}
                        className="media"
                        style={{ minHeight: '190px' }}
                        image={
                            product.avatar && isValidHttpUrl(product.avatar)
                                ? product.avatar
                                : `${global.site_url}/uploads/product/${product.avatar}`
                        }
                        title={product.title}
                    />
                    <CardContent className="card-content">
                        <Typography
                            variant="subtitle1"
                            style={{
                                textAlign: 'left',
                                fontWeight: '600',
                                color: theme?.theme?.colors,
                            }}
                            component="h2"
                        >
                            {product.title}
                        </Typography>
                        <Typography className="mb-3" style={{ textAlign: 'left' }} component="h4">
                            {product.title}
                        </Typography>
                        <div className="d-flex justify-content-between align-items-center bordered-top flex-nowrap">
                            <Typography
                                variant="body2"
                                style={{ color: theme?.theme?.colors, fontWeight: '600' }}
                                className="price-text"
                            >
                                {product.price}
                            </Typography>
                            <FavouriteCheckbox
                                watchlisted={product.watchlistid}
                                project_id={product.id}
                            />
                            {/* <IconButton aria-label="add to favorites">
                                <FavoriteBorderIcon className="favorite-icon" />
                            </IconButton> */}
                        </div>
                    </CardContent>
                </Card>
            </Grid>
        </>
        // </Grid>
    )
}
